const params = [
  {
    programs: "Digital Publishing Certificate",
    value: 0,
  },
];

export default params;
